// eslint-disable-next-line import/prefer-default-export
export const isTestEnvironment = () =>
  typeof process !== "undefined" &&
  !!process.env &&
  process.env.NODE_ENV === "test"
